export default __webpack_public_path__ + "static/extralight-46c2329f035308147791d7b8b69b80fe.woff2";